import React, { memo } from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Cristal DVH mal pedido y $130.000 ARS tirados a la basura', 'Marco rombado porque no verificaste las diagonales', 'Instalación que filtra porque tapaste los drenajes con silicona', 'Presupuesto a ojo sin saber si ganás o perdés'];
  return <section className="py-16 relative overflow-hidden" data-id="element-218">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-219">
        <FadeIn data-id="element-220">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-center mb-6 text-white leading-tight" data-id="element-221">
            ¿Cuántos cristales más vas a perder{' '}
            <span className="text-red-400" data-id="element-222">trabajando de memoria?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-223">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-10 leading-relaxed" data-id="element-224">
            Sabés lo que hacés. Pero calculás de cabeza, medís y rezás, instalás
            cruzando los dedos y presupuestás por lo que el cliente acepta.
            <br data-id="element-225" />
            <br data-id="element-226" />
            <strong className="text-white" data-id="element-227">
              No es falta de habilidad. Es falta de sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-228">
          <ul className="space-y-6" data-id="element-229">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-230">
                <li className="flex items-start gap-4" data-id="element-231">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-232" />
                  <span className="text-lg text-gray-300" data-id="element-233">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-234">
          <div className="mt-10 text-center" data-id="element-235">
            <p className="text-2xl md:text-3xl font-heading font-bold text-gold" data-id="element-236">
              ¿Y si este fuera el último trabajo que hacés sin sistema?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}